import Api from "../../service/api";
import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";

export const actionTypes = {
  ROOM_PENDING: "ROOM_PENDING",
  ROOM_SUCCESS: "ROOM_SUCCESS",
  ROOM_ERROR: "ROOM_ERROR",

  ROOM_ADD_PENDING: "ROOM_ADD_PENDING",
  ROOM_ADD_SUCCESS: "ROOM_ADD_SUCCESS",
  ROOM_ADD_ERROR: "ROOM_ADD_ERROR",

  ROOM_EDIT_PENDING: "ROOM_EDIT_PENDING",
  ROOM_EDIT_SUCCESS: "ROOM_EDIT_SUCCESS",
  ROOM_EDIT_ERROR: "ROOM_EDIT_ERROR",

  BOOK_ROOM_PENDING: "BOOK_ROOM_PENDING",
  BOOK_ROOM_SUCCESS: "BOOK_ROOM_SUCCESS",
  BOOK_ROOM_ERROR: "BOOK_ROOM_ERROR",

  CHECKOUT_ROOM_PENDING: "CHECKOUT_ROOM_PENDING",
  CHECKOUT_ROOM_SUCCESS: "CHECKOUT_ROOM_SUCCESS",
  CHECKOUT_ROOM_ERROR: "CHECKOUT_ROOM_ERROR",

  OCCUPANCY_CHECK_PENDING: "OCCUPANCY_CHECK_PENDING",
  OCCUPANCY_CHECK_SUCCESS: "OCCUPANCY_CHECK_SUCCESS",
  OCCUPANCY_CHECK_ERROR: "OCCUPANCY_CHECK_ERROR",

  OCCUPANCY_HISTORY_PENDING: "OCCUPANCY_HISTORY_PENDING",
  OCCUPANCY_HISTORY_SUCCESS: "OCCUPANCY_HISTORY_SUCCESS",
  OCCUPANCY_HISTORY_ERROR: "OCCUPANCY_HISTORY_ERROR",

  CURRENT_OCCUPANCY_PENDING: "CURRENT_OCCUPANCY_PENDING",
  CURRENT_OCCUPANCY_SUCCESS: "CURRENT_OCCUPANCY_SUCCESS",
  CURRENT_OCCUPANCY_ERROR: "CURRENT_OCCUPANCY_ERROR",

  ROOM_ARCHIVE_PENDING: "ROOM_ARCHIVE_PENDING",
  ROOM_ARCHIVE_SUCCESS: "ROOM_ARCHIVE_SUCCESS",
  ROOM_ARCHIVE_ERROR: "ROOM_ARCHIVE_ERROR",

  CANCEL_BOOKING_PENDING: "CANCEL_BOOKING_PENDING",
  CANCEL_BOOKING_SUCCESS: "CANCEL_BOOKING_SUCCESS",
  CANCEL_BOOKING_ERROR: "CANCEL_BOOKING_ERROR",

  SET_ACTIVE_MEETING_ROOMS_TAB: "SET_ACTIVE_MEETING_ROOMS_TAB",
  SET_ROOM_MANAGEMENT_PAGE: "SET_ROOM_MANAGEMENT_PAGE",
  SET_OCCUPANCY_HISTORY_PAGE: "SET_OCCUPANCY_HISTORY_PAGE",
  SET_MY_OCCUPANCY_PAGE: "SET_MY_OCCUPANCY_PAGE",
  SET_MY_OCCUPANCY_FILTERS: "SET_MY_OCCUPANCY_FILTERS",
  SET_OCCUPANCY_HISTORY_FILTERS: "SET_OCCUPANCY_HISTORY_FILTERS",
  CLEAR_ROOM_PAGINATION_STATE: "CLEAR_ROOM_PAGINATION_STATE",
};

// List rooms (fetches active rooms list, sets roomList)
export function listRooms(params) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ROOM_PENDING,
      payload: {
        roomPending: true,
        roomSuccess: false,
        roomError: null,
      },
    });
    dispatch(showLoader());

    Api.get("rooms/active", params)
      .then((response) => {
        dispatch(hideLoader());
        // Handle both paginated ({ docs, totalDocs }) and non-paginated (array) responses
        const hasDocs = response.data && response.data.docs;
        const rooms = hasDocs ? response.data.docs : (response.data || response);
        const pagination = hasDocs ? response.data : null;

        dispatch({
          type: actionTypes.ROOM_SUCCESS,
          payload: {
            roomPending: false,
            roomSuccess: true,
            roomError: null,
            roomList: Array.isArray(rooms) ? rooms : [],
            roomPagination: pagination,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.ROOM_ERROR,
          payload: {
            roomPending: false,
            roomSuccess: false,
            roomError: "Failed to load rooms list.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to get rooms list.",
          })
        );
      });
  };
}

// Add Room (POST /rooms without roomId)
export function addRoom(data, listParams) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ROOM_ADD_PENDING,
      payload: {
        roomAddPending: true,
        roomAddSuccess: false,
        roomAddError: null,
      },
    });
    dispatch(showLoader());

    Api.post("rooms", data)
      .then((response) => {
        if (response.data && response.data.rid && String(response.data.rid).startsWith("e")) {
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.ROOM_ADD_ERROR,
            payload: {
              roomAddPending: false,
              roomAddSuccess: false,
              roomAddError: response.message || "Failed to add room.",
            },
          });
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              msg: response.message || "Failed to add room.",
            })
          );
          return;
        }

        dispatch({
          type: actionTypes.ROOM_ADD_SUCCESS,
          payload: {
            roomAddPending: false,
            roomAddSuccess: true,
            roomAddError: null,
            newRoom: response.data,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message || "Successfully added new room.",
          })
        );
        // Refresh list
        dispatch(listRooms(listParams));
        dispatch(hideLoader());
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.ROOM_ADD_ERROR,
          payload: {
            roomAddPending: false,
            roomAddSuccess: false,
            roomAddError: err.response?.data?.message || err.message || "Failed to add room.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to add room.",
          })
        );
      });
  };
}

// Edit Room (POST /rooms with roomId)
export function editRoom(data, listParams) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ROOM_EDIT_PENDING,
      payload: {
        roomEditPending: true,
        roomEditSuccess: false,
        roomEditError: null,
      },
    });
    dispatch(showLoader());

    Api.post("rooms", data)
      .then((response) => {
        if (response.data && response.data.rid && String(response.data.rid).startsWith("e")) {
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.ROOM_EDIT_ERROR,
            payload: {
              roomEditPending: false,
              roomEditSuccess: false,
              roomEditError: response.message || "Failed to update room.",
            },
          });
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              msg: response.message || "Failed to update room.",
            })
          );
          return;
        }

        dispatch({
          type: actionTypes.ROOM_EDIT_SUCCESS,
          payload: {
            roomEditPending: false,
            roomEditSuccess: true,
            roomEditError: null,
            updatedRoom: response.data,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message || "Successfully updated room.",
          })
        );
        // Refresh list
        dispatch(listRooms(listParams));
        dispatch(hideLoader());
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.ROOM_EDIT_ERROR,
          payload: {
            roomEditPending: false,
            roomEditSuccess: false,
            roomEditError: err.response?.data?.message || err.message || "Failed to update room.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to update room.",
          })
        );
      });
  };
}

// Book Room
export function bookRoom(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BOOK_ROOM_PENDING,
      payload: {
        bookPending: true,
        bookSuccess: false,
        bookError: null,
      },
    });
    dispatch(showLoader());

    Api.post("rooms/book", data)
      .then((response) => {
        dispatch(hideLoader());
        if (response.data && response.data.rid && String(response.data.rid).startsWith("e")) {
          dispatch({
            type: actionTypes.BOOK_ROOM_ERROR,
            payload: {
              bookPending: false,
              bookSuccess: false,
              bookError: response.message || "Failed to book room.",
            },
          });
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              msg: response.message || "Failed to book room.",
            })
          );
          return;
        }
        dispatch({
          type: actionTypes.BOOK_ROOM_SUCCESS,
          payload: {
            bookPending: false,
            bookSuccess: true,
            bookError: null,
            bookingResult: response.data,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message || "Successfully booked room.",
          })
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.BOOK_ROOM_ERROR,
          payload: {
            bookPending: false,
            bookSuccess: false,
            bookError: "Failed to book room.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to book room.",
          })
        );
      });
  };
}

// Check Out Room
export function checkOutRoom(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CHECKOUT_ROOM_PENDING,
      payload: {
        checkoutPending: true,
        checkoutSuccess: false,
        checkoutError: null,
      },
    });
    dispatch(showLoader());

    Api.put("rooms/checkout", data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.CHECKOUT_ROOM_SUCCESS,
          payload: {
            checkoutPending: false,
            checkoutSuccess: true,
            checkoutError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message || "Successfully checked out room.",
          })
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.CHECKOUT_ROOM_ERROR,
          payload: {
            checkoutPending: false,
            checkoutSuccess: false,
            checkoutError: "Failed to check out room.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to check out room.",
          })
        );
      });
  };
}

// Check Occupancy (point-in-time check)
export function checkOccupancy(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.OCCUPANCY_CHECK_PENDING,
      payload: {
        occupancyCheckPending: true,
        occupancyCheckSuccess: false,
        occupancyCheckError: null,
      },
    });
    dispatch(showLoader());

    Api.post("rooms/occupancy/check", data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.OCCUPANCY_CHECK_SUCCESS,
          payload: {
            occupancyCheckPending: false,
            occupancyCheckSuccess: true,
            occupancyCheckError: null,
            occupancyCheckResult: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.OCCUPANCY_CHECK_ERROR,
          payload: {
            occupancyCheckPending: false,
            occupancyCheckSuccess: false,
            occupancyCheckError: "Failed to check occupancy.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to check occupancy.",
          })
        );
      });
  };
}

// Occupancy History
export function getOccupancyHistory(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.OCCUPANCY_HISTORY_PENDING,
      payload: {
        occupancyHistoryPending: true,
        occupancyHistorySuccess: false,
        occupancyHistoryError: null,
      },
    });
    dispatch(showLoader());

    const payload = {
      page: 1,
      limit: 100, // large default for UI parts that don't do pagination yet
      ...data
    };

    Api.post("rooms/occupancy/history", payload)
      .then((response) => {
        dispatch(hideLoader());
        const historyList = response.data && response.data.docs ? response.data.docs : response.data;
        const pagination = response.data && response.data.docs ? response.data : null;

        dispatch({
          type: actionTypes.OCCUPANCY_HISTORY_SUCCESS,
          payload: {
            occupancyHistoryPending: false,
            occupancyHistorySuccess: true,
            occupancyHistoryError: null,
            occupancyHistoryList: historyList,
            occupancyHistoryPagination: pagination,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.OCCUPANCY_HISTORY_ERROR,
          payload: {
            occupancyHistoryPending: false,
            occupancyHistorySuccess: false,
            occupancyHistoryError: "Failed to get occupancy history.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to get occupancy history.",
          })
        );
      });
  };
}

// Fetch Current Occupancy list
export function getCurrentOccupancy() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CURRENT_OCCUPANCY_PENDING,
      payload: {
        currentOccupancyPending: true,
        currentOccupancySuccess: false,
        currentOccupancyError: null,
      },
    });
    dispatch(showLoader());

    const timePlusOneMin = new Date(Date.now() + 60000);
    const currentTime = timePlusOneMin.toISOString().split('.')[0] + 'Z';
    Api.get(`rooms/occupancy/current?currentTime=${currentTime}`)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.CURRENT_OCCUPANCY_SUCCESS,
          payload: {
            currentOccupancyPending: false,
            currentOccupancySuccess: true,
            currentOccupancyError: null,
            currentOccupancyList: response.data || [],
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.CURRENT_OCCUPANCY_ERROR,
          payload: {
            currentOccupancyPending: false,
            currentOccupancySuccess: false,
            currentOccupancyError: "Failed to load current occupancy.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to get current occupancy.",
          })
        );
      });
  };
}

// Archive/Remove Room
export function archiveRoom(data, listParams) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ROOM_ARCHIVE_PENDING,
      payload: {
        roomArchivePending: true,
        roomArchiveSuccess: false,
        roomArchiveError: null,
      },
    });
    dispatch(showLoader());

    Api.put("rooms/archive", data)
      .then((response) => {
        if (response.data && response.data.rid && String(response.data.rid).startsWith("e")) {
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.ROOM_ARCHIVE_ERROR,
            payload: {
              roomArchivePending: false,
              roomArchiveSuccess: false,
              roomArchiveError: response.message || "Failed to archive room.",
            },
          });
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              msg: response.message || "Failed to archive room.",
            })
          );
          return;
        }

        dispatch({
          type: actionTypes.ROOM_ARCHIVE_SUCCESS,
          payload: {
            roomArchivePending: false,
            roomArchiveSuccess: true,
            roomArchiveError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message || "Successfully archived room.",
          })
        );
        // Refresh room list
        dispatch(listRooms(listParams));
        dispatch(hideLoader());
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.ROOM_ARCHIVE_ERROR,
          payload: {
            roomArchivePending: false,
            roomArchiveSuccess: false,
            roomArchiveError: err.response?.data?.message || err.message || "Failed to archive room.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to archive room.",
          })
        );
      });
  };
}

// Cancel Booking
export function cancelBooking(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CANCEL_BOOKING_PENDING,
      payload: {
        cancelBookingPending: true,
        cancelBookingSuccess: false,
        cancelBookingError: null,
      },
    });
    dispatch(showLoader());

    Api.put("rooms/booking/cancel", data)
      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.CANCEL_BOOKING_SUCCESS,
          payload: {
            cancelBookingPending: false,
            cancelBookingSuccess: true,
            cancelBookingError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message || "Successfully cancelled booking.",
          })
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.error(err);
        dispatch({
          type: actionTypes.CANCEL_BOOKING_ERROR,
          payload: {
            cancelBookingPending: false,
            cancelBookingSuccess: false,
            cancelBookingError: "Failed to cancel booking.",
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.response?.data?.message || err.message || "Failed to cancel booking.",
          })
        );
      });
  };
}

export function setActiveMeetingRoomsTab(tab) {
  sessionStorage.setItem("activeMeetingRoomsTab", tab);
  return {
    type: actionTypes.SET_ACTIVE_MEETING_ROOMS_TAB,
    payload: tab,
  };
}

export function setRoomManagementPage(page) {
  sessionStorage.setItem("roomManagementPage", page);
  return {
    type: actionTypes.SET_ROOM_MANAGEMENT_PAGE,
    payload: page,
  };
}

export function setOccupancyHistoryPage(page) {
  sessionStorage.setItem("occupancyHistoryPage", page);
  return {
    type: actionTypes.SET_OCCUPANCY_HISTORY_PAGE,
    payload: page,
  };
}

export function setMyOccupancyPage(page) {
  sessionStorage.setItem("myOccupancyPage", page);
  return {
    type: actionTypes.SET_MY_OCCUPANCY_PAGE,
    payload: page,
  };
}

export function setMyOccupancyFilters(dateIsoString) {
  if (dateIsoString) {
    sessionStorage.setItem("myOccupancySelectedDate", dateIsoString);
  } else {
    sessionStorage.removeItem("myOccupancySelectedDate");
  }
  return {
    type: actionTypes.SET_MY_OCCUPANCY_FILTERS,
    payload: dateIsoString,
  };
}

export function setOccupancyHistoryFilters(filtersObj) {
  if (filtersObj) {
    sessionStorage.setItem("occupancyHistoryFilters", JSON.stringify(filtersObj));
  } else {
    sessionStorage.removeItem("occupancyHistoryFilters");
  }
  return {
    type: actionTypes.SET_OCCUPANCY_HISTORY_FILTERS,
    payload: filtersObj,
  };
}

export function clearRoomPaginationState() {
  sessionStorage.removeItem("activeMeetingRoomsTab");
  sessionStorage.removeItem("roomManagementPage");
  sessionStorage.removeItem("occupancyHistoryPage");
  sessionStorage.removeItem("myOccupancyPage");
  sessionStorage.removeItem("myOccupancySelectedDate");
  sessionStorage.removeItem("occupancyHistoryFilters");
  return {
    type: actionTypes.CLEAR_ROOM_PAGINATION_STATE,
  };
}
